import { useState } from "react"
import { useHistory, Link } from "react-router-dom"
import { useDispatch } from "react-redux"
import { createUser } from "../store/actions/usersAction"

export default function Register(){
  const [UserRegister, setUserRegister] = useState({
    id: '',
    email: '',
    password: '',
    role: 'admin',
    phoneNumber: '',
    address: ''
  })
  
  const dispatch = useDispatch()
  const history = useHistory()

  const handleRegister = () => {
    dispatch(createUser(UserRegister))

    history.push('/login')
    setUserRegister({
      id: '',
      email: '',
      password: '',
      phoneNumber: '',
      address: ''
    })
    
    // fetch('http://localhost:3000/users', {
    //     method: 'POST',
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       id: +UserRegister.id,
    //       email: UserRegister.email,
    //       password: UserRegister.password,
    //       role: UserRegister.role,
    //       phoneNumber: UserRegister.phoneNumber,
    //       address: UserRegister.address
    //     })
    //   })
    //   .then(() => {
    //     history.push('/login')
    //     setUserRegister({
    //       id: '',
    //       email: '',
    //       password: '',
    //       role: '',
    //       phoneNumber: '',
    //       address: ''
    //     })
    //   })
    //   .catch((err) => {
    //     console.log(err)
    //   });
  }
  
  const handleOnChange = (e) => {
    const { name, value } = e.target
    setUserRegister({...UserRegister, [name]: value})
  }
  return (
    <>
      <div className="container">
        <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
                <div className="row">
                    <div className="col-lg-5 d-none d-lg-block bg-register-image">
                      <img src="https://cdn.pixabay.com/photo/2019/05/23/13/03/video-production-4223885_960_720.jpg" alt=""style={{width: 500, height: 400}} />
                    </div>
                    <div className="col-lg-7">
                        <div className="p-5">
                            <div className="text-center">
                                <h1 className="h4 text-gray-900 mb-4">Create an Account!</h1>
                            </div>
                            <form className="user" onSubmit={handleRegister}>
                                <div className="form-group">
                                    <input type="email" className="form-control form-control-user" id="exampleInputEmail"
                                        placeholder="Email Address" name="email" value={UserRegister.email}
                                        onChange={e => handleOnChange(e)} />
                                </div>
                                <div className="form-group">
                                    <input type="password" className="form-control form-control-user"
                                      id="exampleInputPassword" placeholder="Password"  name="password" value={UserRegister.password}
                                      onChange={e => handleOnChange(e)}/>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                        <input type="text" className="form-control form-control-user" id="exampleaddress"
                                            placeholder="address"  name="address" value={UserRegister.address}
                                            onChange={e => handleOnChange(e)}/>
                                    </div>
                                    <div className="col-sm-6">
                                        <input type="text" className="form-control form-control-user" id="examplephoneNumber"
                                            placeholder="Phone Number"  name="phoneNumber" value={UserRegister.phoneNumber}
                                            onChange={e => handleOnChange(e)}/>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary btn-user btn-block">
                                    Register Account
                                </button>
                            </form>
                            <div className="text-center">
                                <Link to='/login'>
                                  <p className="small">Already have an account? Login!</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </>
  )
}